<template>
  <el-dialog :modal="false" width="600px" :close-on-click-modal="false" title="选择产品" :visible.sync="relatedProductModalVisible">
    <div class="select-wrap">
      <el-select class="select-item" v-model="filterData.productPlatformId" placeholder="选择产品库">
        <el-option v-for="item in productPlatformList" :key="item.platformId" :label="item.name" :value="item.platformId"> </el-option>
      </el-select>
      <el-input class="select-item" placeholder="搜索产品名称或id" v-model="filterData.search"></el-input>
      <el-button style="margin-left: auto" @click="resetFilter">重置</el-button>
      <el-button type="primary" @click="searchData">查询</el-button>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="product_id" label="产品ID"> </el-table-column>
      <el-table-column prop="name" label="产品名称"> </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="confirmProduct(scope.row)">确定</el-button>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer"> </span>
  </el-dialog>
</template>

<script>
import { getProductPlatform, getDpaDetail } from "@/api/promotion.js";
import { mapState } from "vuex";

export default {
  data() {
    return {
      relatedProductModalVisible: false,
      productPlatformList: [],
      filterData: {
        productPlatformId: "",
        search: "",
      },
      tableData: [],
    };
  },

  computed: {
    ...mapState({
      adCount: (state) => state.PromotionTtV2.baseData.advertiser_id,
    }),
  },

  methods: {
    showModal() {
      getProductPlatform({
        advertiserId: this.adCount,
      }).then((res) => {
        this.productPlatformList = res.data.list;
      });
      this.searchData();
      this.relatedProductModalVisible = true;
    },
    resetFilter() {
      this.filterData = {
        productPlatformId: "",
        search: "",
      };
      this.searchData();
    },
    searchData() {
      getDpaDetail({
        advertiserId: this.adCount,
        ...this.filterData,
      }).then((res) => {
        this.tableData = res.data.list;
      });
    },
    confirmProduct(row) {
      this.relatedProductModalVisible = false;
      this.$emit("selectOk", row);
    },
  },
};
</script>

<style lang="less" scoped>
.select-wrap {
  display: flex;
  margin-top: 16px;
  .select-item {
    width: 200px;
    margin: 0px 24px 16px 0px;
  }
  .data-range {
    position: relative;
    margin-bottom: 16px;
    /deep/.el-range__icon {
      position: absolute;
      right: 6px;
      top: 0px;
    }
    /deep/.el-range-separator {
      line-height: 24px;
      color: rgba(0, 0, 0, 0.25);
    }
  }
}
</style>
